import { render, staticRenderFns } from "./OrderHelp.vue?vue&type=template&id=8e9986c8&scoped=true&"
import script from "./OrderHelp.vue?vue&type=script&lang=js&"
export * from "./OrderHelp.vue?vue&type=script&lang=js&"
import style0 from "./OrderHelp.vue?vue&type=style&index=0&id=8e9986c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9986c8",
  null
  
)

export default component.exports